import React from "react";
import LegalLayout from "./LegalLayout";
import useSeo from "@/hooks/useSeo";

export default function Cookies() {
  useSeo({
    title: "Cookie policy",
    description: "Utilizziamo esclusivamente cookie tecnici essenziali per il login e la sessione. Nessun tracker di marketing, nessun cookie di profilazione. Conforme al provvedimento del Garante privacy del 10 giugno 2021.",
    path: "/cookies",
  });
  return (
    <LegalLayout
      testid="legal-cookies"
      kicker="Legal"
      title="Cookie policy"
      updatedAt="27 febbraio 2026"
    >
      <p>
        La presente Cookie Policy illustra i cookie e le tecnologie di tracciamento utilizzate su
        <strong> autofattura.dasabo.com</strong> (di seguito, il &laquo;Sito&raquo;), ai sensi del
        provvedimento del Garante privacy del 10 giugno 2021.
      </p>

      <div className="callout">
        <p>
          <strong>In due righe.</strong> Non usiamo cookie di profilazione, non ti mostriamo pubblicità,
          non condividiamo la tua navigazione con circuiti di advertising di terze parti. Usiamo solo
          cookie tecnici indispensabili all&apos;autenticazione e alla sessione.
        </p>
      </div>

      <h2>1. Cosa sono i cookie</h2>
      <p>
        I cookie sono piccoli file di testo che i siti visitati inviano al browser dell&apos;utente,
        dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.
      </p>

      <h2>2. Cookie tecnici (sempre attivi)</h2>
      <ul>
        <li><strong>auth_token</strong> — localStorage, non è un cookie in senso stretto ma
        assolve alla stessa funzione. Contiene il JWT firmato di sessione. TTL 168h.</li>
        <li><strong>auth_user</strong> — localStorage, contiene i dati minimi dell&apos;utente
        loggato (id, email, nome, flag admin). Usato per rendering condizionato dell&apos;interfaccia.
        TTL 168h.</li>
        <li><strong>Cookie di infrastruttura Cloudflare / provider cloud</strong> — utilizzati dal
        nostro CDN per il bilanciamento del carico e la protezione DDoS. TTL variabile.</li>
      </ul>
      <p>
        La base giuridica di questi cookie è il legittimo interesse ex art. 6 §1 f GDPR e la loro
        installazione <strong>non richiede consenso</strong> ai sensi del provvedimento Garante del
        10 giugno 2021.
      </p>

      <h2>3. Cookie di profilazione</h2>
      <p><strong>Non ne utilizziamo.</strong></p>

      <h2>4. Cookie di terze parti</h2>
      <p>
        Non ospitiamo pixel di tracciamento, iframe pubblicitari o script di terze parti che
        installino cookie di marketing (Google Analytics, Meta Pixel, LinkedIn Insight ecc.). Se in
        futuro dovessimo introdurne, aggiorneremo questa policy e ti chiederemo il consenso preventivo
        mediante banner conforme al provvedimento del Garante.
      </p>

      <h2>5. Come disabilitare i cookie</h2>
      <p>
        Puoi disabilitare i cookie tecnici agendo dalle impostazioni del browser. La disabilitazione
        potrebbe però compromettere la fruibilità del Servizio (login, permanenza in sessione,
        rendering delle aree private).
      </p>
      <ul>
        <li>Chrome: chrome://settings/cookies</li>
        <li>Firefox: about:preferences#privacy</li>
        <li>Safari: Preferenze &rarr; Privacy</li>
        <li>Edge: edge://settings/content/cookies</li>
      </ul>

      <h2>6. Titolare</h2>
      <p>
        DASABO SRL, Via Imperatore Federico 100, 90143 Palermo (PA), P.IVA/CF 07407380828 &mdash;
        PEC dasabo@pec.it &mdash; privacy@dasabo.com.
      </p>
    </LegalLayout>
  );
}
